import React, { useState, useEffect } from "react";
import axios from "../common/axios";
import Layout from "../layout/Layout";
import { Circles } from "react-loader-spinner";
import { MFormTableInput } from "../common/formtable/mdrawingtableInput";
import useDocumentTitle from "../common/useDocumentTitle";
import { useLocation } from "react-router-dom";
import { SearchableCombobox } from "../components/SearchableCombobox";

const DrawingMInput = () => {
  const [tableData, setTableData] = useState([]);
  const [projectCodeList, setProjectCodeList] = useState([]);
  const [projectCode, setProjectCode] = useState({
    projectnumber: "",
    projectname: "",
  });
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  useDocumentTitle("SHI DP 제작도 실적");

  // 프로젝트 코드 상태 초기화
  useEffect(() => {
    const projectnumber = localStorage.getItem("projectnumber");
    const projectname = localStorage.getItem("projectname");
    if (projectname && projectnumber) {
      setProjectCode({
        projectnumber: projectnumber,
        projectname: projectname,
      });
    }
  }, []);

  // 프로젝트 코드 변경 시 로컬 스토리지에 저장
  useEffect(() => {
    if (projectCode && projectCode.projectname !== "") {
      localStorage.setItem("projectnumber", projectCode.projectnumber);
      localStorage.setItem("projectname", projectCode.projectname);
    }
  }, [projectCode]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userResponse = await axios.post(
          `/dpcurrent_user`,
          {},
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        setUserData(userResponse.data); // Set user data using Recoil
      } catch (userError) {
        console.error("Error fetching user data:", userError);
        // Handle error in fetching user data
      }
    };
    fetchData();
  }, [location]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(`/getprojectlist`);
      if (res.data.success) {
        const data = res.data.data;
        setProjectCodeList(data);
      }
    };
    fetchData();
  }, [location]);

  useEffect(() => {
    const fetchData = async () => {
      if (projectCode !== null && projectCode.projectnumber) {
        setLoading(true);
        const res = await axios.get(
          `/getdpMdata?path=${projectCode.projectnumber}`
        );
        if (res.data.success) {
          const vendor = userData.companyName;

          let data = res.data.data.data.map((v) => ({
            ...v,
            BIMActualDate: v.BIMActualDate && new Date(v.BIMActualDate),
            DrawingReleaseActualDate:
              v.DrawingReleaseActualDate &&
              new Date(v.DrawingReleaseActualDate),
            BIMPlanDate: v.BIMPlanDate && new Date(v.BIMPlanDate),
            DrawingReleasePlanDate:
              v.DrawingReleasePlanDate && new Date(v.DrawingReleasePlanDate),
            ReceiptScheduledDate:
              v.ReceiptScheduledDate && new Date(v.ReceiptScheduledDate),
          }));

          if (vendor !== "삼성중공업") {
            data = data.filter((v) => v.VendorsDPK === vendor);
          }

          setTableData(data);
        }
        setLoading(false);
      }
    };
    fetchData();
  }, [projectCode, userData]);

  return (
    <>
      <Layout pageTitle="제작도 · 실적 입력">
        <div className="flex h-full min-h-0 flex-col">
          <div className="flex shrink-0 items-end justify-end gap-3 py-4 px-6">
            <SearchableCombobox
              label="Project"
              value={projectCode?.projectnumber || ""}
              onChange={(newValue) => {
                const found = projectCodeList.find((p) => p.projectnumber === newValue);
                setProjectCode(found || { projectnumber: "", projectname: "" });
              }}
              options={projectCodeList.map((p) => ({
                value: p.projectnumber,
                label: p.projectname || "",
              }))}
              placeholder="Project 선택"
              width={300}
            />
          </div>
          <div className="flex flex-1 min-h-0 flex-col px-6 pb-6">
            {loading &&
            (projectCode !== null) & (projectCode.projectnumber !== "") &&
            tableData.length > 0 ? (
              <div className="loadingContainer">
                <Circles
                  ariaLabel="loading"
                  color="#00BFFF"
                  height={100}
                  width={100}
                />
              </div>
            ) : (
              <MFormTableInput
                tabeldata={tableData}
                projectCode={projectCode}
              />
            )}
          </div>
        </div>
      </Layout>
    </>
  );
};
export default DrawingMInput;
